<template>
  <div class="row">
    <div class="w-50 px-1">
      <div class="form-row mt-2">
        <label for="height">{{ $t('props.height') }} <strong>(A)</strong></label>
        <b-input-group size="sm" prepend="cm" class="mb-2 mr-sm-2 mb-sm-0">
          <b-input v-model.number="value.height" id="length" :placeholder="$t('props.height')" type="number"></b-input>
        </b-input-group>
      </div>
      <div class="form-row mt-2">
        <label for="diameter">{{ $t('props.diameter') }} <strong>(B)</strong></label>
        <b-input-group size="sm" prepend="cm" class="mb-2 mr-sm-2 mb-sm-0">
          <b-input v-model.number="value.diameter" id="length" :placeholder="$t('props.diameter')" type="number"></b-input>
        </b-input-group>
      </div>
    </div>
    <div class="w-50 px-1 d-flex align-items-center">
      <b-img :src="require('@/assets/images/inputs/measure.png')" fluid alt="Responsive image"></b-img>
    </div>
  </div>
</template>
<script>
import { InputField } from '../Input.mixin'

export default {
  name: 'InputBottleSize',
  extends: InputField
}
</script>
